import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
  output,
} from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'eventq-attachment-card',
  imports: [MatIcon, PrefixUrlPipe],
  templateUrl: './attachment-card.html',
  styleUrl: './attachment-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-busy]': 'loading() ? "true" : null',
  },
})
export class EventqAttachmentCard {
  readonly category = input('');
  readonly fileName = input.required<string>();
  /** When empty, the expiration line is omitted. */
  readonly expirationDate = input('');
  readonly fileIconSrc = input('/assets/workspace/attachments/file-type.svg');
  readonly loading = input(false, { transform: booleanAttribute });
  /** When empty, Download is a non-navigating control. */
  readonly downloadHref = input('');
  readonly downloadFileName = input('attachment.png');

  readonly clicked = output<void>();
  readonly preview = output<void>();

  /** Lowercase extension derived from `fileName` (e.g. `jpg`, `xlsx`). */
  readonly fileType = computed(() => {
    const name = this.fileName().trim();
    const dot = name.lastIndexOf('.');
    if (dot < 0 || dot === name.length - 1) {
      return '';
    }
    return name.slice(dot + 1).toLowerCase();
  });

  onActivate(): void {
    if (this.loading()) {
      return;
    }
    this.clicked.emit();
  }

  onPreview(event: Event): void {
    event.stopPropagation();
    if (this.loading()) {
      return;
    }
    this.preview.emit();
  }

  onDownloadActivate(event: Event): void {
    event.stopPropagation();
  }
}
